import { LuSearch, LuSearchX } from 'react-icons/lu'
import { useTheme } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import useSearch, { openSearch, clearSearch } from '../models/useSearch'

export default function Search(props: ButtonProps) {
  const theme = useTheme()
  const query = useSearch(s => s.query)
  const active = query.length > 0

  const clickHandler = () => {
    if (active) clearSearch()
    else openSearch()
  }

  return (
    <Button onClick={clickHandler} {...props}>
      <Typography variant="caption" color={props.disabled ? 'textDisabled' : 'textSecondary'} sx={{
        lineHeight: 1.2
      }}>
        {active ? 'Clear' : 'Search'}
      </Typography>
      <Stack
        sx={{
          width: 38,
          height: 38,
          alignItems: 'center',
          justifyContent: 'center',
          color: 'contrast.medium'
        }}>
        {active ? (
          <LuSearchX fontSize={20} color={props.disabled ? theme.palette.contrast.low : undefined} />
        ) : (
          <LuSearch fontSize={20} color={props.disabled ? theme.palette.contrast.low : undefined} />
        )}
      </Stack>
    </Button>
  )
}
